unable to read source [project]/packages/src/components/compound/SelectRow/SelectRow.tsx